import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { ScrollArea } from '@/components/ui/scroll-area';
import { METADATA_FIELDS } from './auto-uploads/constants';

export function MetadataFieldsSelector({ selectedFields, onFieldsChange, columns = 1 }) {
  const handleFieldToggle = (fieldId, checked) => {
    const newSelected = new Set(selectedFields);
    if (checked) {
      newSelected.add(fieldId);
    } else {
      newSelected.delete(fieldId);
    }
    onFieldsChange(newSelected);
  };

  const handleSelectAll = () => {
    onFieldsChange(new Set(METADATA_FIELDS.map(f => f.id)));
  };

  const handleDeselectAll = () => {
    onFieldsChange(new Set());
  };

  const gridClass = columns === 2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1';

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <Label className="text-base">
          Metadata Fields ({selectedFields.size}/{METADATA_FIELDS.length})
        </Label>
        <div className="flex gap-2">
          <Button size="sm" variant="outline" onClick={handleSelectAll}>
            Select All
          </Button>
          <Button size="sm" variant="outline" onClick={handleDeselectAll}>
            Deselect All
          </Button>
        </div>
      </div>

      <ScrollArea className="h-48 w-full rounded-md border">
        <div className={`grid ${gridClass} gap-3 p-4`}>
          {METADATA_FIELDS.map(field => (
            <div key={field.id} className="flex items-start space-x-3">
              <Checkbox
                id={`field-${field.id}`}
                checked={selectedFields.has(field.id)}
                onCheckedChange={checked => handleFieldToggle(field.id, checked)}
                className="mt-1"
              />
              <label htmlFor={`field-${field.id}`} className="cursor-pointer space-y-0.5">
                <div className="font-medium text-sm">{field.label}</div>
                <div className="text-xs text-muted-foreground">{field.description}</div>
              </label>
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
